module.exports = __webpack_public_path__ + "static/CHART_5-fcb4174b9053a98afe8887431f95ee10.png";